<ol class="breadcrumb mat-typography background-iq-color-1">
  <li>
    <a id="{{idPrefix}}crumb_dashboard" class="iq-link-style" routerLink="/dashboard"> {{ 'dashboard.title' | translate }} </a>
  </li>
  <li *ngFor="let item of breadcrumbs; last as isLast; let idx = index;">
    &nbsp; &raquo; &nbsp;
    <a id="{{idPrefix}}crumb_{{idx}}"
       class="iq-link-style"
       routerLink="{{item.url}}" *ngIf="!isLast && !item.disabled">
      {{ item.label | translate }}
    </a>
    <span *ngIf="isLast || item.disabled" class="iq-link-style disabled"> {{ item.label | translate }} </span>
  </li>
</ol>
